export function calculateVisibleCategoryCount(categoryWidths, overflowWidth, gap, availableWidth) {
  const widths = Array.isArray(categoryWidths) ? categoryWidths : [];
  if (widths.length === 0) return 0;

  const spacing = Number.isFinite(gap) ? Math.max(0, gap) : 0;
  const available = Number.isFinite(availableWidth) ? Math.max(0, availableWidth) : 0;
  const allCategoriesWidth = widths.reduce((sum, width) => sum + width, 0)
    + Math.max(0, widths.length - 1) * spacing;

  if (allCategoriesWidth <= available) return widths.length;

  let visibleCount = 0;
  let usedWidth = 0;
  for (const width of widths) {
    const nextUsedWidth = usedWidth + (visibleCount > 0 ? spacing : 0) + width;
    const remainingCount = widths.length - visibleCount - 1;
    const overflowChipWidth = Number.isFinite(overflowWidth) ? Math.max(0, overflowWidth) : 0;
    const widthWithOverflow = nextUsedWidth
      + (remainingCount > 0 ? spacing + overflowChipWidth : 0);

    if (widthWithOverflow > available) break;
    usedWidth = nextUsedWidth;
    visibleCount += 1;
  }

  // Never render an overflow count by itself: if the first category and
  // overflow chip cannot share a row, CSS wraps the +N chip onto the next row.
  return Math.max(1, visibleCount);
}
